import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";

export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE];

export const getSupportedLanguage = (language) => {
  const normalizedLanguage = String(language || "")
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];

  return SUPPORTED_LANGUAGES.includes(normalizedLanguage)
    ? normalizedLanguage
    : DEFAULT_LANGUAGE;
};

const savedLanguage = getSupportedLanguage(
  localStorage.getItem("staywork_language"),
);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: savedLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (language) => {
  const supportedLanguage = getSupportedLanguage(language);
  localStorage.setItem("staywork_language", supportedLanguage);
  document.documentElement.lang = supportedLanguage;
});

document.documentElement.lang = savedLanguage;

export default i18n;
